import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapActions, mapMutations } from 'vuex';
import pickBy from 'lodash/pickBy';
import isNil from 'lodash/isNil';
import defer from 'lodash/defer';
import shallowEqualObjects from 'shallow-equal/objects';
import categoryTcVars from '~/modules/tagCommander/categoryTcVars';
import registerStoreModule from '~/helpers/store-helper';
import search from '~/store/modules/search';
import pageActions from '~/store/modules/pageActions';
import { extractCategoryFilterByFromQuery, extractCategorySortByFromQuery, extractCategoryOrderByFromQuery, extractCategoryPreviousPageFromQuery, extractCategoryNextPageFromQuery, extractCategoryQueryFromFilterBy, extractSelectedFilters } from '~/helpers/extract-helper';
import { extractCategoryQueryFromFilterBy as extractAlgoliaCategoryQueryFromFilterBy, extractCategoryFilterByFromQuery as extractAlgoliaCategoryFilterByFromQuery, extractSelectedFilters as extractAlgoliaSelectedFilters } from '~/helpers/algolia-extract-helper';
import getCorvusProviderName from '~/helpers/search-data-helpers';
export default {
  name: 'ResultsDataProvider',
  mixins: [categoryTcVars],
  data: function data() {
    return {
      loadingProducts: true,
      loadingNextPage: false,
      loadingPreviousPage: false,
      unwatchSearchQuery: null,
      unwatchNextPage: null,
      unwatchPreviousPage: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    baseURL: 'request/baseURL',
    locale: 'i18n/locale',
    description: 'search/description',
    products: 'search/products',
    productsCount: 'search/productsCount',
    filterBy: 'pageActions/filterBy',
    orderBy: 'pageActions/orderBy',
    sortBy: 'pageActions/sortBy',
    previousPage: 'pageActions/previousPage',
    nextPage: 'pageActions/nextPage',
    sortReplica: 'search/algoliaReplica'
  })), {}, {
    isAlgoliaProvider: function isAlgoliaProvider() {
      return getCorvusProviderName(this) === 'algolia';
    },
    updateFilterBy: function updateFilterBy() {
      var updated = {};

      if (this.description) {
        var filtersUpdated = extractAlgoliaSelectedFilters(this.filterBy, this.description.filters);
        updated = filtersUpdated.reduce(function (acc, filters) {
          if (filters.label) {
            if (Object.keys(acc).indexOf(filters.filter) === -1) {
              return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, filters.filter, [filters.facet]));
            }

            acc[filters.filter].push(filters.facet);
          }

          return acc;
        }, {});
      }

      return updated;
    },
    categoryQuery: function categoryQuery() {
      if (this.isAlgoliaProvider) {
        var filtersUpdated = this.updateFilterBy;
        return _objectSpread(_objectSpread({}, extractAlgoliaCategoryQueryFromFilterBy(filtersUpdated)), {}, {
          sort: this.sortBy,
          order: this.orderBy
        });
      }

      return _objectSpread(_objectSpread({}, extractCategoryQueryFromFilterBy(this.filterBy)), {}, {
        sort: this.sortBy,
        order: this.orderBy
      });
    },
    breadcrumb: function breadcrumb() {
      var _this = this;

      var breadcrumb = this.description.breadcrumb || [];
      return breadcrumb.map(function (entry) {
        return {
          label: entry.title,
          url: "/".concat(_this.locale.market, "/").concat(_this.locale.language)
        };
      });
    },
    selectedFilters: function selectedFilters() {
      if (this.isAlgoliaProvider) {
        return this.description ? extractAlgoliaSelectedFilters(this.filterBy, this.description.filters) : false;
      }

      return this.description ? extractSelectedFilters(this.filterBy, this.description.filters) : false;
    },
    currentPath: function currentPath() {
      return this.description ? "".concat(this.baseURL).concat(this.buildSearchUrl(this.locale, this.description.query)) : false;
    },
    pageTitle: function pageTitle() {
      var _ref, _ref2;

      var replacement = {
        x: this.productsCount,
        y: (_ref2 = this.description) != null ? _ref2.query : _ref2,
        z: (_ref = this.description) != null ? _ref.suggest_query : _ref
      };
      var tradName = 'searchTitle';

      if (!this.productsCount) {
        tradName = 'searchTitleNoResults';
      } else if (this.description.is_corrected) {
        tradName = 'searchTitleCorrect';
      } else if (this.description.suggest_query) {
        tradName = 'searchTitleSuggest';
      }

      return this.$i18n.tc(tradName, this.productsCount, replacement);
    },
    isSearchQueryAlgolia: function isSearchQueryAlgolia() {
      return this.$route.query.query;
    }
  }),
  created: function created() {
    var _this2 = this;

    registerStoreModule(this.$store, 'search/', search);
    registerStoreModule(this.$store, 'pageActions/', pageActions);

    if (process.client) {
      var _this$$route = this.$route,
          keyword = _this$$route.params.keyword,
          query = _this$$route.query;
      var args = {
        keyword: keyword,
        query: query
      };
      this.resetPagination();
      this.resetFilters();
      this.resetSearch();
      this.setDefaultFilterBy(extractCategoryFilterByFromQuery(query));

      if (this.isAlgoliaProvider) {
        this.setDefaultFilterBy(extractAlgoliaCategoryFilterByFromQuery(query));
      }

      this.setDefaultSortBy(extractCategorySortByFromQuery(query));
      this.setDefaultOrderBy(extractCategoryOrderByFromQuery(query));
      this.setPreviousPage(extractCategoryPreviousPageFromQuery(query));
      this.setNextPage(extractCategoryNextPageFromQuery(query));

      try {
        this.fetchSearch(args).then(function () {
          _this2.loadingProducts = false;

          _this2.scrollBackToProduct(localStorage.getItem('currentProduct'));

          _this2.setTcVars();

          localStorage.removeItem('currentProduct');
        });
      } catch (error) {
        this.$logger.error(error);
      }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this3.unwatchSearchQuery = _this3.$watch('categoryQuery', /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(oldVal, newVal) {
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (shallowEqualObjects(oldVal, newVal)) {
                            _context.next = 6;
                            break;
                          }

                          _this3.loadingProducts = true;
                          _context.next = 4;
                          return _this3.handleWatcher(_this3.fetchSearch, 1);

                        case 4:
                          _this3.resetPagination();

                          _this3.loadingProducts = false;

                        case 6:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x, _x2) {
                  return _ref3.apply(this, arguments);
                };
              }());
              _this3.unwatchNextPage = _this3.$watch('nextPage', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var predicate;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        predicate = _this3.nextPage === 1 && _this3.previousPage === 1;

                        if (predicate) {
                          _context2.next = 6;
                          break;
                        }

                        _this3.loadingNextPage = true;
                        _context2.next = 5;
                        return _this3.handleWatcher(_this3.appendProducts, _this3.nextPage);

                      case 5:
                        _this3.loadingNextPage = false;

                      case 6:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              })));
              _this3.unwatchPreviousPage = _this3.$watch('previousPage', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var predicate;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        predicate = _this3.nextPage === 1 && _this3.previousPage === 1;

                        if (predicate) {
                          _context3.next = 6;
                          break;
                        }

                        _this3.loadingPreviousPage = true;
                        _context3.next = 5;
                        return _this3.handleWatcher(_this3.prependProducts, _this3.previousPage);

                      case 5:
                        _this3.loadingPreviousPage = false;

                      case 6:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              })));

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    this.unwatchSearchQuery();
    this.unwatchNextPage();
    this.unwatchPreviousPage();
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapMutations({
    setDefaultFilterBy: 'pageActions/SET_DEFAULT_FILTERBY',
    setDefaultSortBy: 'pageActions/SET_DEFAULT_SORTBY',
    setDefaultOrderBy: 'pageActions/SET_DEFAULT_ORDERBY',
    setPreviousPage: 'pageActions/SET_PREVIOUS_PAGE',
    setNextPage: 'pageActions/SET_NEXT_PAGE',
    resetPagination: 'pageActions/RESET_PAGINATION',
    resetFilters: 'pageActions/RESET_FILTERS',
    resetSearch: 'search/RESET_SEARCH'
  })), mapActions({
    fetchSearch: 'search/fetchContent',
    appendProducts: 'search/appendProducts',
    prependProducts: 'search/prependProducts'
  })), {}, {
    handleWatcher: function handleWatcher(handler, page) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var keyword, query;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                keyword = _this4.$route.params.keyword;
                query = _objectSpread(_objectSpread({}, _this4.categoryQuery), {}, {
                  page: page
                });
                _context5.prev = 2;
                _context5.next = 5;
                return handler({
                  query: query,
                  keyword: keyword
                });

              case 5:
                _this4.$router.push({
                  query: pickBy(query, function (e) {
                    return !isNil(e);
                  })
                });

                if (!_this4.isSearchQueryAlgolia) _this4.setTcVars();
                _context5.next = 12;
                break;

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5["catch"](2);

                _this4.$logger.error(_context5.t0);

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[2, 9]]);
      }))();
    },
    scrollBackToProduct: function scrollBackToProduct(arg) {
      if (arg) {
        var currentProduct = JSON.parse(arg);
        defer(function () {
          var product = document.getElementById(currentProduct);

          if (product) {
            window.scrollTo({
              top: product.offsetTop
            });
          }
        });
      }
    }
  }),
  render: function render() {
    return this.$scopedSlots.default({
      nextPage: this.nextPage,
      previousPage: this.previousPage,
      loadingNextPage: this.loadingNextPage,
      loadingPreviousPage: this.loadingPreviousPage,
      loadingProducts: this.loadingProducts,
      products: this.products,
      productsCount: this.productsCount,
      breadcrumb: this.description ? this.breadcrumb : false,
      selectedFilters: this.selectedFilters,
      currentPath: this.currentPath,
      description: this.description,
      filters: this.description ? this.description.filters : false,
      pageTitle: this.pageTitle
    });
  }
};